import { httpGet, httpPost, httpPut, httpGetWithOutToken } from "../../utils/httpMethods";
import { PLAN_URL } from "../restEndpoint";

export const getAllPlan = async () => {
  return await httpGet({ url: `${PLAN_URL}` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const createPlan = async (planData) => {
  return await httpPost({ url: `${PLAN_URL}`, payload: planData })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const updatePlan = async (id, planData) => {
  return await httpPut({ url: `${PLAN_URL}/${id}`, payload: planData })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const getPlanUpdate = async (id, planName) => {
  return await httpPut({ url: `${PLAN_URL}/${id}`, payload: { planName } })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const getAllPlanForUnAuth = async () => {
  return await httpGetWithOutToken({ url: `${PLAN_URL}` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};
